import { LockRecord } from '@/types/LockRecord';
import Accordion from "@components/elements/Accordion";
import Button from "@components/elements/Button";
import { tifi } from "@assets/icons/currencies";
import { T } from 'react-translator-component';
import { getDateTime } from "@utils/formatters";

export const LockItem: React.FC<{ record: LockRecord, onWithdraw: (startTs: number) => Promise<void> }> = ({ record, onWithdraw }) => {
  const nowTs = Date.now();
  const { startTs, endTs, principal, reflection, reward } = record;
  return <Accordion
    number={principal}
    title={<div className="flex items-center">
      <div className="mr-2 flex">
        <img src={tifi} alt="TIFI" />
      </div>
      <span className="text-white text-sm lg:text-base">TIFI</span>
    </div>}
    body={<>
      <div className="flex item-center lg:justify-between lg:flex-row flex-col">
        <div>
          <small className="text-neutral-black-10">{T('Time of Deposit')}</small>
        </div>
        <div>
          <small className="text-white">{getDateTime(startTs)}</small>
        </div>
      </div>
      <div className="flex item-center lg:justify-between lg:flex-row flex-col">
        <div>
          <small className="text-neutral-black-10">{T('Time of Maturity')}</small>
        </div>
        <div>
          <small className="text-white">{getDateTime(endTs)}</small>
        </div>
      </div>
      <div className="flex item-center lg:justify-between lg:flex-row flex-col">
        <div>
          <small className="text-neutral-black-10">{T('Principal')}</small>
        </div>
        <div>
          <small className="text-white">{principal} TIFI</small>
        </div>
      </div>
      <div className="flex item-center lg:justify-between lg:flex-row flex-col">
        <div>
          <small className="text-neutral-black-10">{T('Reflection Reward Till Now')}</small>
        </div>
        <div>
          <small className="text-white">{reflection} TIFI</small>
        </div>
      </div>
      <div className="flex item-center lg:justify-between lg:flex-row flex-col">
        <div>
          <small className="text-neutral-black-10">{T('Fix Rate Reward')}</small>
        </div>
        <div>
          <small className="text-white">{reward} TIFI</small>
        </div>
      </div>
      <div className="mt-6">
        {endTs > nowTs ? <div className='item-center'>
          <small className="text-white">{T('You cannot withdraw or change the deposit until the time of maturity.')}</small>
        </div> : <>
          <small className="text-white">
            {T('By clicking the Withdraw button, you will receive ')}
            {Number(principal) + Number(reward) + Number(reflection)} TIFI</small>
          <Button label={T('Withdraw')}
            className="mt-4 bg-transparent border-2 border-white rounded-xl text-white"
            onClick={() => { onWithdraw(Number(startTs) / 1000); }}
          />
        </>}
      </div>
    </>}
  />
}